



















import { defineComponent, PropType } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "MoreMenuItemDefault",
  components: { BaseIcon },
  props: {
    item: { type: Object as PropType<IMoreMenuItem>, required: true },
    underlined: { type: Boolean, default: false },
  },
});
